<script setup lang="ts">
/**
 * Wave 1 — Property access modals (Agent C).
 * Single bullet item used inside <ul> lists in every modal variant.
 */

const { accent = 'gold' } = defineProps<{
  accent?: 'gold' | 'green';
}>();

const checkClasses = computed(() =>
  accent === 'green' ? 'bg-success/15 text-success' : 'bg-gold-primary-100/20 text-gold-primary-120',
);
</script>

<template>
  <li class="flex items-start gap-2.5 text-[13.5px] leading-[1.5] text-black-80">
    <span
      class="mt-[3px] inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full"
      :class="checkClasses"
      aria-hidden="true"
    >
      <svg
        width="11"
        height="11"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </span>
    <span><slot /></span>
  </li>
</template>
